import api from './api';

export const dashboardService = {
  async getStats() {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },
  
  async getProductivity() {
    const response = await api.get('/dashboard/productivity');
    return response.data;
  },
  
  async getTraffic() {
    const response = await api.get('/dashboard/traffic');
    return response.data;
  },
  
  async getTurnover() {
    const response = await api.get('/dashboard/turnover');
    return response.data;
  },

  async getTodaySnapshot() {
    const response = await api.get('/dashboard/today-snapshot');
    return response.data;
  },

  async getResults(department = 'sales') {
    const response = await api.get('/dashboard/results', { params: { department } });
    return response.data;
  }
};
